export default {
  welcome: "Welcome to Bwell!",
  welcomeBack: "Welcome back!",
  pastPlansInfo: "Below are your previous lifestyle plans.",
  getStartedPrompt: "Click the button below to get started!",
  reminderActivePlan: "Remember to finish your ongoing lifestyle plan!",
  continue: "Continue",
  continueWhereLeftOff: "Continue where you left off",
  latestPlan: "My latest lifestyle plan",
  showAllPlans: "Show all my previous lifestyle plans",
  hideOlderPlans: "Hide previous lifestyle plans",
  newPlanPrompt: "Is it time for a new lifestyle plan?",
  startFirstPlanPrompt: "Click the button below to get started with your first lifestyle plan!",
  createNewPlan: "Create a new lifestyle plan",
  getStarted: "Get started",
  loading: "Loading...",
  loadingPlan: "Fetching plan...",
  errorHeader: "Oh no!",
  errorMessage: "Something went wrong while fetching your plan. Please try again.",
  okay: "Okay"
};
